import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import constants from 'constants';

const {
  API_CERTIFICATES
} = constants;

function CertificateLink({
  token,
  webinarId
}) {
  return (
    <div className="container_download col l1" onClick={(e) => {e.stopPropagation()}}>
     <a href={`${API_CERTIFICATES}/${webinarId}?token=${token}`} target="_blank"><p className="section_live_download"></p></a>
     <a href={`${API_CERTIFICATES}/${webinarId}?token=${token}`} target="_blank">
        <img src="/assets/img/grey-download.png" alt="icon" />
      </a>
    </div>
  );
}

CertificateLink.defaultProps = {};

CertificateLink.propTypes = {};

export default CertificateLink;



/** WEBPACK FOOTER **
 ** ./src/components/CpdLocker/CertificateLink.jsx
 **/